<script setup lang="ts">
defineProps<{
  state: 'loading' | 'error' | 'empty';
  title: string;
  message: string;
  detail?: string;
}>();

defineEmits<{ retry: [] }>();
</script>

<template>
  <section class="page-state" :class="`is-${state}`" role="status">
    <span>{{ state === 'error' ? 'DATA / UNAVAILABLE' : state === 'loading' ? 'CONNECTING' : 'NO RECORDS' }}</span>
    <div v-if="state === 'loading'" class="loading-line"><i></i></div>
    <h2>{{ title }}</h2>
    <p>{{ message }}</p>
    <code v-if="detail">{{ detail }}</code>
    <button v-if="state === 'error'" class="button button-primary" type="button" @click="$emit('retry')">重新加载</button>
  </section>
</template>
